import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    count: 0,
    resultValue: '',
    newsValue: '',
    wxSharlink:'', //微信链接分享
    params: {
      zsId: '',
      id: '',
      exhibitsIntro: '',
      techParam: '',
      column24: '',
      viewColumn15: '',
      id: '',
      sizeForm: {},
      lunboImg: [],
      listArr: [],
      column20: [],
    },
    news: {
      sizeForm: {},
      dateTimeNow: '',
    },
  },
  mutations: {
    updatewxShare(state,wxSharlink){
      state.wxSharlink=wxSharlink
    },
    updataCount(state, num) {
      state.count = num;
    },
    updateparams(state, data) {
      sessionStorage.setItem('resultValue', JSON.stringify(data));
      state.params = data;
    },
    updatenews(state, data) {
      sessionStorage.setItem('newsValue', JSON.stringify(data));
      state.news = data;
    },
  },
  actions: {},
  getters: {
    getResultValue(state) {
      state.resultValue = sessionStorage.getItem('resultValue');
      return state.resultValue;
    },
    getNewsValue(state) {
      state.newsValue = sessionStorage.getItem('newsValue');
      return state.newsValue;
    },
  },
});
